var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShares(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.364,
    height: 11.997,
    viewBox: "0 0 11.364 11.997",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Shares",
    d: "M9.493,11.825l-3.226-1.76a2.21,2.21,0,1,1,0-3.137L9.493,5.17a2.21,2.21,0,1,1,.6,1.108L6.872,8.037a2.219,2.219,0,0,1,0,.921l3.226,1.76a2.21,2.21,0,1,1-.6,1.108Z",
    transform: "translate(-2.5 -2.499)",
    fill: "#707070"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShares);
export default __webpack_public_path__ + "static/media/Shares.eecc350ac00957aa5f7a6906a0ee68a9.svg";
export { ForwardRef as ReactComponent };